import React, {useMemo, useState} from "react";
import {makeStyles} from "@mui/styles";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent, Typography} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {SubmissionForm} from "../forms";
import {submissionService} from "../../services";
import {arrays, forms, strings} from "@atttomyx/shared-utils";
import "./submissionDialog.css";

const useStyles = makeStyles(theme => ({
    paper: {
        maxWidth: "600px",
        minWidth: "300px",
    },
}));

const toData = (questions, submission) => {
    const data = {
        valid: false,
    };

    if (submission) {
        const previous = {}

        submission.questions.forEach(question => {
            previous[question.ask] = question.reply;
        });

        questions.forEach(question => {
            data[question.id] = previous[question.ask];
        });

        let valid = false;
        questions.forEach(question => {
            valid = valid || strings.isNotBlank(data[question.id]);
        });
        data.valid = valid;
    }

    return data;
};

const SubmissionDialog = (props) => {
    const { snackbar, theme, questionnaire, questions, submission, preview, onCancel, onSave } = props;
    const [ data, setData ] = useState(toData(questions, submission));
    const [ saving, setSaving ] = useState(false);

    const description = useMemo(() => {
        return arrays.splitOnNewline(questionnaire.description);
    }, [questionnaire.description]);

    const submitForm = () => {
        setSaving(true);

        const success = (saved) => {
            snackbar.setSuccess(questionnaire.title + " saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        };

        const questionsAndAnswers = [];

        questions.forEach(question => {
            arrays.addTo(questionsAndAnswers, {
                questionId: question.id,
                ask: question.ask,
                reply: data[question.id],
            });
        });

        submissionService.saveSubmission(questionnaire.id, questionsAndAnswers, success, failure);
    };

    return <Dialog
        open={true}
        aria-labelledby="submission-dialog"
        classes={useStyles()}
    >
        <ClosableDialogTitle onClose={onCancel}>
            {questionnaire.title}
        </ClosableDialogTitle>
        <DialogContent className="submission-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <>
                    {description.length > 0 ?
                        <div className="description">
                            {description.map(line => strings.isBlank(line) ? null :
                                <Typography key={line} variant="caption" component="p">
                                    {line}
                                </Typography>)}
                        </div> : null}
                    <SubmissionForm
                        data={data}
                        questions={questions}
                        theme={theme}
                        onChange={setData}
                    />
                </>}
        </DialogContent>
        {!saving && !preview ? <DialogActions>
            <Button color="primary"
                    disabled={!data.valid || !forms.differ(toData(questions, submission), data)}
                    onClick={submitForm}>
                Save
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default SubmissionDialog;
